const obj = {
  handleErrorPassBlur: obj => {
    let value = false;
    if (obj.repeat_pass == '') {
      value = false;
    } else if (obj.pass != obj.repeat_pass) {
      value = true;
    } else {
      value = false;
    }
    return value;
  },
  handleErrorPassKeyPress: obj => {
    let value = false;
    if (obj.errorPass) {
      if (obj.repeat_pass == '') {
        value = false;
      } else if (obj.pass != obj.repeat_pass) {
        value = true;
      } else {
        value = false;
      }
    }
    return value;
  },
  handleErrorButton: obj => {
    let value = false;
    if (obj.pass == obj.repeat_pass) {
      value = false;
    } else {
      value = true;
    }
    return value;
  }
};

export default obj;



// WEBPACK FOOTER //
// ./source/client/containers/function/account.js